export const style = {
  wrapper: {
    background: `#F5F3F4`
  },
  h3: {
    fontSize: `24px`,
    fontWeight: 300,
    lineHeight: `24px`,
    color: `black`,
    margin: `0 0 32px 0`
  },
  h4: {
    fontSize: `20px`,
    fontWeight: 300,
    color: `#a94545`,
    margin: `0 0 14px 0`
  },
  strong: {
    fontWeight: 700
  },
  headerIcon: {
    background: `#a94545`,
    color: `white`,
    marginRight: `10px`,
    width: `35px`,
    height: `35px`,
    borderRadius: `50%`,
    lineHeight: `35px`,
    fontSize: `17px`,
    textAlign: `center`
  },
  p: {
    fontSize: `14px`,
    fontWeight: 400,
    lineHeight: `22px`,
    margin: `0 0 20px`
  },
  link: {
    color: `#a94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/About/style/offer.js